import React from 'react';
import FormFitCoin from '../../components/Struttura/LaMiaStruttura/formFitcoin';

/* Pagina FitCoin della struttura (voce FitCoin del menu): saldo, guadagnati, spesi e movimenti. Prima stava nel tab FitCoins di La mia struttura. */
export const FitCoinStruttura = () => <FormFitCoin />;

export default FitCoinStruttura;
